import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import {
  Home,
  People,
  LocationCity,
  TrendingUp,
} from '@mui/icons-material';

const StatsSection = () => {
  const stats = [
    {
      icon: <Home />,
      number: '100+',
      label: 'Properties Listed',
      description: 'Carefully vetted properties across prime locations',
    },
    {
      icon: <People />,
      number: '500+',
      label: 'Happy Clients',
      description: 'Satisfied customers who found their dream homes',
    },
    {
      icon: <LocationCity />,
      number: '3',
      label: 'Cities Covered',
      description: 'Focused coverage in key metropolitan areas',
    },
    {
      icon: <TrendingUp />,
      number: '98%',
      label: 'Success Rate',
      description: 'Client satisfaction and successful transactions',
    },
  ];

  return (
    <Box
      sx={{
        py: 8,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" sx={{ mb: 6 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: 'white',
            }}
          >
            Our Achievements
          </Typography>
          <Typography variant="h6" sx={{ maxWidth: 600, mx: 'auto', opacity: 0.9 }}>
            Numbers that speak for our commitment to excellence in real estate services
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: 3,
                  color: 'white',
                  textAlign: 'center',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mb: 2,
                    }}
                  >
                    {React.cloneElement(stat.icon, {
                      sx: {
                        fontSize: 48,
                        color: 'rgba(255, 255, 255, 0.9)',
                      },
                    })}
                  </Box>
                  
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 700,
                      mb: 1,
                      background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {stat.number}
                  </Typography>
                  
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      color: 'white',
                    }}
                  >
                    {stat.label}
                  </Typography>
                  
                  <Typography
                    variant="body2"
                    sx={{
                      opacity: 0.8,
                      lineHeight: 1.5,
                    }}
                  >
                    {stat.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default StatsSection;
